module.exports = __webpack_public_path__ + "static/img/Archer-Day-Wicks.a09f5e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Archer-Day-Wicks.jpg
// module id = andv
// module chunks = 0